// src/app/core/guards/rpd.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { guardWithProfile } from './guard.utils';

/**
 * CanMatchFn — gates the /rpd section (Sigurimet → RPD).
 * Requires `rpd.view` or `rpd.manage` (admin.full_access bypasses).
 */
export const rpdGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canViewRpd(), '/dashboard');
};

/**
 * CanMatchFn — gates the data-entry routes (Hyrja e shënimeve).
 * Viewing alone is not enough; the list stays reachable.
 */
export const rpdManageGuard: CanMatchFn = () => {
  const perm = inject(PermissionService);
  return guardWithProfile(() => perm.canManageRpd(), '/rpd');
};
